import { render, staticRenderFns } from "./newsletter-subscription-page.vue?vue&type=template&id=2a44da65&scoped=true&"
import script from "./newsletter-subscription-page.vue?vue&type=script&lang=js&"
export * from "./newsletter-subscription-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44da65",
  null
  
)

export default component.exports